import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-da4ed26e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-ticketSelection__content l-container l-bg-primary" }
const _hoisted_2 = ["data-qa"]
const _hoisted_3 = {
  key: 3,
  class: "m-section"
}
const _hoisted_4 = { class: "m-blockNotice -warning" }
const _hoisted_5 = { class: "m-blockNotice__content" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EventPresentationComponent = _resolveComponent("EventPresentationComponent")!
  const _component_ModeSelectionComponent = _resolveComponent("ModeSelectionComponent")!
  const _component_EventPromotionComponent = _resolveComponent("EventPromotionComponent")!
  const _component_vue_recaptcha = _resolveComponent("vue-recaptcha")!
  const _component_BestSeatSelectionComponent = _resolveComponent("BestSeatSelectionComponent")!
  const _component_SeatmapComponent = _resolveComponent("SeatmapComponent")!
  const _component_event_information = _resolveComponent("event-information")!
  const _component_PromotionPanel = _resolveComponent("PromotionPanel")!
  const _component_price_level_filter = _resolveComponent("price-level-filter")!
  const _component_SelectionComponent = _resolveComponent("SelectionComponent")!
  const _component_bottom_panel = _resolveComponent("bottom-panel")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["p-ticketSelection__header l-container", {'-absolute body__no-scroll': _ctx.isMobile && _ctx.displayModeState.seatmap.isSeatmapVisible}])
    }, [
      _withDirectives(_createVNode(_component_EventPresentationComponent, {
        "event-information": _ctx.data.eventInformation
      }, null, 8, ["event-information"]), [
        [_vShow, true]
      ]),
      (_ctx.displayStateStore.hasSeatmapConfig && _ctx.displayStateStore.canShowSelection)
        ? (_openBlock(), _createBlock(_component_ModeSelectionComponent, {
            key: 0,
            onActivateSeatmap: _ctx.displayStateStore.updateDisplayModeWith,
            onActivateBestseat: _ctx.displayStateStore.updateDisplayModeWith,
            onToggleEventHeaderExpansion: _ctx.displayStateStore.updateDisplayModeWith
          }, null, 8, ["onActivateSeatmap", "onActivateBestseat", "onToggleEventHeaderExpansion"]))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (_ctx.isMobileMenuOpen())
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.collapseHeader && _ctx.collapseHeader(...args))),
                class: "p-ticketSelection__menuOverlay"
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_ctx.canShowPromotion && _ctx.displayStateStore.modeSelectionState.bestSeat)
        ? (_openBlock(), _createBlock(_component_EventPromotionComponent, {
            key: 0,
            configuration: _ctx.data.configuration
          }, null, 8, ["configuration"]))
        : _createCommentVNode("", true),
      (_ctx.recaptchaStore.isRequired())
        ? (_openBlock(), _createBlock(_component_vue_recaptcha, {
            key: 1,
            sitekey: _ctx.data.configuration.reCaptcha.key,
            size: "invisible",
            onVerify: _ctx.recaptchaStore.handleVerifiedEvent,
            onExpire: _ctx.recaptchaStore.handleExpiredEvent,
            ref: "vueRecaptcha"
          }, null, 8, ["sitekey", "onVerify", "onExpire"]))
        : _createCommentVNode("", true),
      (_ctx.displayStateStore.canShowSelection)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            (_ctx.displayStateStore.getPriceList)
              ? _withDirectives((_openBlock(), _createBlock(_component_BestSeatSelectionComponent, {
                  key: 0,
                  data: _ctx.displayStateStore.getPriceList.priceLevels,
                  currencyOptions: _ctx.data.currencyOptions,
                  eventName: _ctx.data.eventInformation.eventName
                }, null, 8, ["data", "currencyOptions", "eventName"])), [
                  [_vShow, _ctx.displayModeState.bestSeat || !_ctx.displayStateStore.hasSeatmapConfig]
                ])
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("div", {
              id: "seatmap-wrapper",
              class: "p-ticketSelection__seatmapContainer",
              "data-qa": _ctx.PerformanceQASelectors.SEATMAP_WRAPPER
            }, [
              _createVNode(_component_SeatmapComponent, {
                data: _ctx.data,
                selectedFilter: _ctx.selectedPriceFilter
              }, null, 8, ["data", "selectedFilter"])
            ], 8, _hoisted_2), [
              [_vShow, _ctx.displayModeState.seatmap.isSeatmapVisible]
            ])
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.canDisplayWarning())
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (!_ctx.displayStateStore.getPriceList || !_ctx.displayStateStore.getPriceList.priceLevels.length)
                  ? _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_6, null, 512)), [
                      [_directive_translate, { key: _ctx.Translation.Notice_prices_not_available }]
                    ])
                  : (_ctx.displayStateStore.hasDoubleCurrency)
                    ? _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_7, null, 512)), [
                        [_directive_translate, { key: _ctx.Translation.Notice_double_currency }]
                      ])
                    : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_event_information, { data: _ctx.data }, null, 8, ["data"])
    ]),
    (_ctx.isMobile && _ctx.panelState.isPanelOpen && _ctx.displayModeState.seatmap.isSeatmapVisible)
      ? (_openBlock(), _createBlock(_component_bottom_panel, {
          key: 0,
          title: _ctx.panelState.activePanel,
          "trigger-destroy-panel": _ctx.triggerPanelDestroy,
          onDestroyPanel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.panelState.closePanel()))
        }, {
          default: _withCtx(() => [
            (_ctx.panelState.activePanel === _ctx.PanelType.INFO)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_event_information, { data: _ctx.data }, null, 8, ["data"]),
                  _createElementVNode("div", { innerHTML: _ctx.stay22InnerHTML }, null, 8, _hoisted_8)
                ], 64))
              : (_ctx.panelState.activePanel === _ctx.PanelType.PROMO)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(_component_PromotionPanel, {
                      "event-id": _ctx.data.configuration.eventId
                    }, null, 8, ["event-id"])
                  ]))
                : (_ctx.panelState.activePanel === _ctx.PanelType.FILTER)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_price_level_filter, { data: _ctx.data }, null, 8, ["data"])
                    ]))
                  : (_ctx.panelState.activePanel === _ctx.PanelType.SELECTION)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createVNode(_component_SelectionComponent, { data: _ctx.data }, null, 8, ["data"])
                      ]))
                    : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["title", "trigger-destroy-panel"]))
      : _createCommentVNode("", true)
  ], 64))
}